const AddressIcon = () => {
    return (
        <svg width={30} height={35} viewBox="0 0 39 35" fill="none" xmlns="http://www.w3.org/2000/svg">
		  <path d="M30.6192 34.4586H7.70422C5.23182 34.4586 3.22461 32.4514 3.22461 29.979V10.7683H35.0988V29.979C35.0988 32.4514 33.0916 34.4586 30.6192 34.4586Z" fill="#657FA5" />
		  <path d="M36.9512 12.1466H1.38132C0.321718 12.1466 -0.34161 11.0009 0.183883 10.0877L5.58526 0.689171C5.83509 0.258439 6.28305 0 6.77408 0H31.5412C32.0322 0 32.4888 0.258439 32.73 0.689171L38.1314 10.0877C38.6655 11.0009 38.0022 12.1466 36.9512 12.1466Z" fill="#C4C4C4" />
		  <path d="M26.7677 26.292H11.5543C11.1149 26.292 10.7617 25.9388 10.7617 25.4994V18.1253C10.7617 17.686 11.1149 17.3328 11.5543 17.3328H26.7677C27.2071 17.3328 27.5603 17.686 27.5603 18.1253V25.4994C27.5603 25.9388 27.2071 26.292 26.7677 26.292Z" fill="#E4F7FF" />
		</svg>

    )
}

export default AddressIcon;

